import { useEffect, useState } from "react";
import useClient from "../../api/hooks/useClients";
import useIsMobile from "../../hooks/useIsMobile";
import { Client } from "../../interfaces";
import { filterByName } from "../../utils/filters/clientFilter";
import ClientsCard from "./ClientsCard";

const ClientsTable = (props: any) => {
  const { isMobile } = useIsMobile();

  const { clientOnSearchName } = props;

  const { RESPONSES, RESULTS, CTAs } = useClient();

  const [clientsFetched, setlCientsFetched] = useState<Client[]>([]);
  const [clientsFiltered, setlCientsFiltered] = useState<Client[]>([]);
  const [clientsDisplayed, setClientsDisplayed] = useState<Client[]>([]);

  const { setIsToggled } = props.loadMoreToggler;
  const clientsPerLoad = 5;

  useEffect(() => {
    CTAs.getListAll();
  }, [props.resetToggler.isToggled]);

  useEffect(() => {
    if (clientsDisplayed.length < clientsFiltered.length) {
      setIsToggled(false);
    } else if (clientsDisplayed.length === clientsFiltered.length) {
      setIsToggled(true);
    }
  }, [clientsDisplayed]);

  useEffect(() => {
    if (clientsFiltered) {
      const clientsOnDisplay = clientsFiltered/* .slice(
        0,
        clientsPerLoad * props.loadMoreCounter
      ); */
      setClientsDisplayed(clientsOnDisplay);
    }
  }, [clientsFiltered/* , props.loadMoreCounter */]);

  useEffect(() => {
    if (clientsFetched) {
      setlCientsFiltered(clientsFetched);
    }
  }, [clientsFetched]);

  useEffect(() => {
    /* console.log(RESPONSES.getListAllResponse, RESULTS.getListAllResult); */
    if (RESPONSES.getListAllResponse?.ok) {
      setlCientsFetched(RESULTS.getListAllResult?.clients?.data);
    }
  }, [RESPONSES.getListAllResponse]);

  useEffect(() => {
    if (clientOnSearchName !== "") {
      const filteredList = filterByName(clientsFetched, clientOnSearchName);
      setlCientsFiltered(filteredList);
    } else setlCientsFiltered(clientsFetched);
  }, [clientOnSearchName]);

  const renderClients = clientsDisplayed.map((client, key) => {
    return (
      <div
        key={key}
        className="clients-table-row"
        style={{ cursor: "pointer" }}
      >
        <ClientsCard client={client} />
      </div>
    );
  });

  return (
    <div
      className="clients-table"
      style={{
        width: isMobile ? "calc(345px - 66px)" : "",
      }}
    >
      <div
        className="clients-table-fields"
        style={{
          margin: isMobile ? "0 28px 0 -15px" : "",
        }}
      >
        <div className="c-name" style={{ display: "flex" }}>
          <p className="field-label">Name</p>
        </div>
        {!isMobile && (
          <>
            <div className="c-referent" style={{ display: "flex" }}>
              <p className="field-label">Referent</p>
            </div>
            <div
              className="c-mail"
              style={{ display: "flex", justifyContent: "left" }}
            >
              <p className="field-label">E-mail</p>
            </div>
            <div
              className="c-location"
              style={{ display: "flex", justifyContent: "left" }}
            >
              <p className="field-label">Location</p>
            </div>
          </>
        )}
        <div
          className="c-spent "
          style={{ display: "flex", justifyContent: "right" }}
        >
          <p className="field-label">Spent</p>
        </div>
      </div>
      <div className="divider" style={{ width: "100%", marginTop: "10px" }} />
      <div className="offers-table-results scrollable-element">
        {renderClients}
      </div>
    </div>
  );
};
export default ClientsTable;
